<app-iframe
  #appIframe
  [route]="route$ | async"
  [loading]="loading$ | async"
  (pageNotFound)="onPageNotFound()"
>
</app-iframe>
